<template>
  <div class="custom-bet-market">
    <div
      v-for="(item, idx) in list"
      :key="idx"
      class="market-item"
    >
      <div :class="['left', { 'circle-icon': isSimple }]">
        <span
          v-if="!isSimple"
          :class="[
            'svg-wrap',
            {
              'icon-won': item.status === 1,
              'icon-lost': item.status === 2,
              'icon-void': item.status === 3 || item.status === 4
            }
          ]"
        >
          <InlineSvg
            v-if="item.status === 1"
            icon="~public/images/inline/single-check.svg"
            width="8px"
          />

          <InlineSvg
            v-else-if="item.status === 2"
            icon="~public/images/inline/close.svg"
            width="10px"
          />

          <InlineSvg
            v-else-if="item.status === 3 || item.status === 4"
            icon="~public/images/inline/void.svg"
            width="13px"
          />

          <InlineSvg
            v-else
            icon="~public/images/inline/time.svg"
            width="13px"
          />
        </span>
        <span v-else />
      </div>

      <div class="right">
        <div :class="['outcome', { 'outcome-light': isSimple }]">
          {{ item.outcome.description }}
        </div>
        <div class="market">
          {{ item.market.description }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CustomBetMarket',
  props: {
    list: {
      type: Array,
      default: () => {
        return []
      }
    },
    isSimple: {
      type: Boolean,
      default: false
    },
    isDarkMode: {
      type: Boolean,
      default: true
    }
  }
}
</script>
<style lang="scss" scoped>
.custom-bet-market {
  position: relative;
  display: flex;
  width: 100%;
  box-sizing: border-box;
  flex-direction: column;
  padding-left: 4px;
}

.market-item {
  display: flex;
  width: 100%;
  height: 50px;
  align-items: center;
}

.left {
  position: relative;
  z-index: 1;
  width: 13px;
  height: 100%;

  &::before,
  &::after {
    position: absolute;
    right: 0;
    left: 0;
    width: 1px;
    height: 20px;
    margin: 0 auto;
    background-color: #444;
    content: '';
  }

  &::before {
    top: 0;
  }

  &::after {
    bottom: 0;
  }

  > span {
    position: absolute;
    z-index: 2;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    width: 100%;
    margin: auto;
  }

  .svg-wrap {
    display: flex;
    width: 13px;
    height: 13px;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    background: #ffca27;

    &.icon-won,
    &.icon-void {
      background: #00b359;
    }

    &.icon-lost {
      background: #666;
    }

    .inline-svg {
      color: #000;
    }
  }

  &.circle-icon {
    position: relative;
    width: 5px;
    height: 100%;

    &::before,
    &::after {
      background-color: #ffca27;
    }

    > span {
      height: 5px;
      border-radius: 50%;
      background-color: #ffca27;

      &::before {
        position: absolute;
        top: -2px;
        left: -2px;
        width: 9px;
        height: 9px;
        border-radius: 50%;
        background-color: #ffca27;
        content: '';
        filter: blur(2px);
        opacity: 0.6;
      }
    }
  }
}

.right {
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-left: 12px;
  font-size: 12px;
  line-height: 16px;

  .outcome {
    color: #fff;
    font-weight: 500;
  }

  .outcome-light {
    color: #000;
  }

  .market {
    margin-top: 2px;
    color: #666;
  }
}

.custom-bet-market .market-item:first-of-type .left::before,
.custom-bet-market .market-item:last-of-type .left::after {
  display: none;
}

[data-mode='light'] .custom-bet-market {
  .left {
    &::before,
    &::after {
      background-color: #dfdfdf;
    }

    .svg-wrap .inline-svg {
      color: #fff;
    }
  }

  .right {
    .outcome {
      color: #000;
    }
  }
}
</style>
